// Copyright (c) 2022 Proto Labs, Inc. All Rights Reserved.

/**
 * Get QueryString from key value pair
 * @param {Object} obj
 * @return {String}
 */
export function createQueryStringFromObject(obj: any) {
	let queryString = '';
	if (obj && Object.keys(obj).length) {
		queryString = `?${Object.keys(obj)
			.map((item) => `${item}=${encodeURIComponent(obj[item])}`)
			.join('&')}`;
	}
	return queryString;
}

/**
 * Return querystring value from name
 * @param {String} name
 * @return {String}
 */
export function getQueryStringValue(name: string) {
	const currentLocationDecoded = new URL(decodeURIComponent(window.location.href));
	const params = new URLSearchParams(currentLocationDecoded.search);
	return params.get(name);
}

export default {
	createQueryStringFromObject,
	getQueryStringValue,
};
